module.exports = __webpack_public_path__ + "img/leader_board.5976d640.png";